// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow: auto; /* or overflow: scroll; */
  overflow-x: hidden;
}
/* In your SideBar.css or App.css file */
a {
  color:#777272; /* Change this to the color you want for links */
  text-decoration: none; /* Optional: Remove underline from links */
}

a:hover {
  color:#777272; /* Change this to the color you want when hovering over links */
}

.custom-navs{
    --bs-nav-tabs-border-width:none!important; 
       --bs-nav-tabs-border-color: none; 
       --bs-nav-tabs-border-radius: none; 
       --bs-nav-tabs-link-hover-border-color:none; 
       --bs-nav-tabs-link-active-color:none ; 
       --bs-nav-tabs-link-active-bg:none ; 
       --bs-nav-tabs-link-active-border-color:none ; 
       border-bottom:none!important;
       --bs-nav-link-color: none; 
        --bs-nav-link-hover-color: none; 
        --bs-nav-link-disabled-color:none;
        --bs-nav-link-padding-x: 0;
  }

  .custom-navs:active{
    border-image-source: linear-gradient(to left,#00C853,#B2FF59);
  }
  .custom-accordion{
    --bs-nav-link-color:#121111; 
    --bs-accordion-btn-focus-box-shadow:none;
    border: none;
     
  }
  .custom-acrdn-btn{
    background-color:#f2f2f2!important;
    padding-bottom: 5px !important;
    color: gray ;
    position: relative;
  }
  .sort-data{
    background-color:#f2f2f2!important;
    padding-bottom: 5px !important;
    color: gray;
    font-size: 16px;
  }
  .sort-data:not(.collapsed){
    font-weight:normal !important;
  }
  .custom-acrdn-btn:focus{
   
       box-shadow: none!important; 
  }
  .fixed-sidebar{
    
    position: fixed;
    background: #ffffff;

    top: 30;
    left: 0;
    z-index: 1000;
  }

  .country-edit-icon button{
    width: 10px ;
    height: 32px ;
  }
  
/* .custom-acrdn-btn:not(.collapsed)::after {
  transform: rotate(180deg);
  left: 180px;
  position: absolute;
} */
  /* .custom-acrdn-btn::after{
    padding-right:30px
    ;
    transition: none; 
  } */
  .sortby ::after{
    padding-right: 18px;
  }
  
  
  .custom-acrdn-btn:not(.collapsed) {
    color: #808080!important;
    font-weight:bolder;
    box-shadow:none!important;
    } 
  
  .custom-navs .nav-link.active {
    border-bottom: 2px solid;
    border-image:  linear-gradient(to left,#00C853,#B2FF59);
    border-image-slice: 1;}
  
  .custom-navs .nav-link {
    cursor: pointer;
  }
  .blue-title{
    font-weight: 600;
    color: #5c5a5a!important;
  }

.li-cursor:hover{
  background: #000;
  color: #fff!important;
  border-radius: 2px;
  font-weight: 500;
  max-width: max-content;

}
.custom-body{
  background-color:#f7f7f7;
  padding:0!important;
}
.accordian-sort{
  background-color:#f7f7f7!important;
}
.custom-text{
  columns: #1A1A1A !important;
  font-size: 12px Goldplay !important;
  padding: 3px,0px,0px !important;
  font-weight: 100;
}
.doneimg{
  width: 15px;
}
.listoption{
  position:relative;
  }
  .fixedPosition {
    position: fixed;
    top: 73px; /* Adjust as needed */
    left: 0;
    z-index: 1000;
  }
  .scrollable2 {
    overflow-y: auto;
    height: calc(100vh - 145px);
     overflow-x: hidden;
    /* Customize scrollbar track */
    &::-webkit-scrollbar {
      width: 5px; /* Width of the scrollbar */
    }
  
    /* Customize scrollbar thumb (the draggable handle) */
    &::-webkit-scrollbar-thumb {
      background-color: #dadada; /* Color of the thumb */
      border-radius: 3px !important; /* Rounded corners */
    }
  
    /* Customize scrollbar track when hovered */
    &::-webkit-scrollbar-track:hover {
      background-color: #f0f0f0; /* Change color on hover */
    }
  
    /* Customize scrollbar thumb when hovered */
    &::-webkit-scrollbar-thumb:hover {
      background-color: #dadada; /* Change thumb color on hover */
    }
  }

  .with-margin {
    margin-top: 39px !important;
  }
  
  /* .custom-acrdn-btn:not(.collapsed)::after{
    position:absolute !important ;
    left: 85% !important; 
    transition: var(--bs-accordion-btn-icon-transition) !important;
  } */
  @media screen and (max-width:576px) {
    .with-margin {
      margin-top: 2px !important;
    }
    .fixedPosition {
      position: unset;
       }
       .scrollable2 {
        padding-left: 5px;
        height: -moz-fit-content;
        height: fit-content
         
        }
  }
  @media screen and (max-width: 768px) {
    .text-blue{
     font-size: 12px;
     }
     .override{
     padding-left: 0% !important;
     }
    .custom-acrdn-btn::after{
     padding-right:0px;
   }
   .sidebar{
     padding-right: 0px !important;
   }
   .scrollable1{
     padding-right: 0px;
   }
   }
   @media screen and (max-width: 1200px) {
     .text-blue{
      font-size: 12px !important;
      }
     .custom-acrdn-btn::after{
      padding-right:0px;
    }
    .sidebar{
      padding-right: 0px !important;
    }
    .scrollable1{
      padding-right: 0px;
    }
    .override{
     padding-left: 5px !important;
    }
    }
    @media screen and (max-width: 1440px) {
     .text-blue{
      font-size: 14px;
      }
     .custom-acrdn-btn::after{
      padding-right:0px;
    }
    .sidebar{
      padding-right: 0px !important;
    }
    .scrollable1{
      padding-right: 0px;
    }
    .override{
     padding-left: 5px !important;
    }
    }
    @media screen and (min-width:768px) and (max-width: 991px){
      .sort-hide{
        display: none;
      }
    }`, "",{"version":3,"sources":["webpack://./src/Components/sidebar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,cAAc,EAAE,yBAAyB;EACzC,kBAAkB;AACpB;AACA,wCAAwC;AACxC;EACE,aAAa,EAAE,gDAAgD;EAC/D,qBAAqB,EAAE,0CAA0C;AACnE;;AAEA;EACE,aAAa,EAAE,+DAA+D;AAChF;;AAEA;IACI,yCAAyC;OACtC,gCAAgC;OAChC,iCAAiC;OACjC,0CAA0C;OAC1C,qCAAqC;OACrC,kCAAkC;OAClC,4CAA4C;OAC5C,4BAA4B;OAC5B,yBAAyB;QACxB,+BAA+B;QAC/B,iCAAiC;QACjC,0BAA0B;EAChC;;EAEA;IACE,6DAA6D;EAC/D;EACA;IACE,2BAA2B;IAC3B,wCAAwC;IACxC,YAAY;;EAEd;EACA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,WAAW;IACX,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;;OAEK,0BAA0B;EAC/B;EACA;;IAEE,eAAe;IACf,mBAAmB;;IAEnB,OAAO;IACP,OAAO;IACP,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;AAEF;;;;GAIG;EACD;;;;KAIG;EACH;IACE,mBAAmB;EACrB;;;EAGA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB;;EAEF;IACE,wBAAwB;IACxB,uDAAuD;IACvD,qBAAqB,CAAC;;EAExB;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;AAEF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;;AAExB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB;EACA;IACE,eAAe;IACf,SAAS,EAAE,qBAAqB;IAChC,OAAO;IACP,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,2BAA2B;KAC1B,kBAAkB;IACnB,8BAA8B;IAC9B;MACE,UAAU,EAAE,2BAA2B;IACzC;;IAEA,qDAAqD;IACrD;MACE,yBAAyB,EAAE,uBAAuB;MAClD,6BAA6B,EAAE,oBAAoB;IACrD;;IAEA,2CAA2C;IAC3C;MACE,yBAAyB,EAAE,0BAA0B;IACvD;;IAEA,2CAA2C;IAC3C;MACE,yBAAyB,EAAE,gCAAgC;IAC7D;EACF;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;;KAIG;EACH;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,eAAe;OACd;OACA;QACC,iBAAiB;QACjB,wBAAkB;QAAlB;;QAEA;EACN;EACA;IACE;KACC,eAAe;KACf;KACA;KACA,2BAA2B;KAC3B;IACD;KACC,iBAAiB;GACnB;GACA;KACE,6BAA6B;GAC/B;GACA;KACE,kBAAkB;GACpB;GACA;GACA;KACE;MACC,0BAA0B;MAC1B;KACD;MACC,iBAAiB;IACnB;IACA;MACE,6BAA6B;IAC/B;IACA;MACE,kBAAkB;IACpB;IACA;KACC,4BAA4B;IAC7B;IACA;IACA;KACC;MACC,eAAe;MACf;KACD;MACC,iBAAiB;IACnB;IACA;MACE,6BAA6B;IAC/B;IACA;MACE,kBAAkB;IACpB;IACA;KACC,4BAA4B;IAC7B;IACA;IACA;MACE;QACE,aAAa;MACf;IACF","sourcesContent":["body {\n  overflow: auto; /* or overflow: scroll; */\n  overflow-x: hidden;\n}\n/* In your SideBar.css or App.css file */\na {\n  color:#777272; /* Change this to the color you want for links */\n  text-decoration: none; /* Optional: Remove underline from links */\n}\n\na:hover {\n  color:#777272; /* Change this to the color you want when hovering over links */\n}\n\n.custom-navs{\n    --bs-nav-tabs-border-width:none!important; \n       --bs-nav-tabs-border-color: none; \n       --bs-nav-tabs-border-radius: none; \n       --bs-nav-tabs-link-hover-border-color:none; \n       --bs-nav-tabs-link-active-color:none ; \n       --bs-nav-tabs-link-active-bg:none ; \n       --bs-nav-tabs-link-active-border-color:none ; \n       border-bottom:none!important;\n       --bs-nav-link-color: none; \n        --bs-nav-link-hover-color: none; \n        --bs-nav-link-disabled-color:none;\n        --bs-nav-link-padding-x: 0;\n  }\n\n  .custom-navs:active{\n    border-image-source: linear-gradient(to left,#00C853,#B2FF59);\n  }\n  .custom-accordion{\n    --bs-nav-link-color:#121111; \n    --bs-accordion-btn-focus-box-shadow:none;\n    border: none;\n     \n  }\n  .custom-acrdn-btn{\n    background-color:#f2f2f2!important;\n    padding-bottom: 5px !important;\n    color: gray ;\n    position: relative;\n  }\n  .sort-data{\n    background-color:#f2f2f2!important;\n    padding-bottom: 5px !important;\n    color: gray;\n    font-size: 16px;\n  }\n  .sort-data:not(.collapsed){\n    font-weight:normal !important;\n  }\n  .custom-acrdn-btn:focus{\n   \n       box-shadow: none!important; \n  }\n  .fixed-sidebar{\n    \n    position: fixed;\n    background: #ffffff;\n\n    top: 30;\n    left: 0;\n    z-index: 1000;\n  }\n\n  .country-edit-icon button{\n    width: 10px ;\n    height: 32px ;\n  }\n  \n/* .custom-acrdn-btn:not(.collapsed)::after {\n  transform: rotate(180deg);\n  left: 180px;\n  position: absolute;\n} */\n  /* .custom-acrdn-btn::after{\n    padding-right:30px\n    ;\n    transition: none; \n  } */\n  .sortby ::after{\n    padding-right: 18px;\n  }\n  \n  \n  .custom-acrdn-btn:not(.collapsed) {\n    color: #808080!important;\n    font-weight:bolder;\n    box-shadow:none!important;\n    } \n  \n  .custom-navs .nav-link.active {\n    border-bottom: 2px solid;\n    border-image:  linear-gradient(to left,#00C853,#B2FF59);\n    border-image-slice: 1;}\n  \n  .custom-navs .nav-link {\n    cursor: pointer;\n  }\n  .blue-title{\n    font-weight: 600;\n    color: #5c5a5a!important;\n  }\n\n.li-cursor:hover{\n  background: #000;\n  color: #fff!important;\n  border-radius: 2px;\n  font-weight: 500;\n  max-width: max-content;\n\n}\n.custom-body{\n  background-color:#f7f7f7;\n  padding:0!important;\n}\n.accordian-sort{\n  background-color:#f7f7f7!important;\n}\n.custom-text{\n  columns: #1A1A1A !important;\n  font-size: 12px Goldplay !important;\n  padding: 3px,0px,0px !important;\n  font-weight: 100;\n}\n.doneimg{\n  width: 15px;\n}\n.listoption{\n  position:relative;\n  }\n  .fixedPosition {\n    position: fixed;\n    top: 73px; /* Adjust as needed */\n    left: 0;\n    z-index: 1000;\n  }\n  .scrollable2 {\n    overflow-y: auto;\n    height: calc(100vh - 145px);\n     overflow-x: hidden;\n    /* Customize scrollbar track */\n    &::-webkit-scrollbar {\n      width: 5px; /* Width of the scrollbar */\n    }\n  \n    /* Customize scrollbar thumb (the draggable handle) */\n    &::-webkit-scrollbar-thumb {\n      background-color: #dadada; /* Color of the thumb */\n      border-radius: 3px !important; /* Rounded corners */\n    }\n  \n    /* Customize scrollbar track when hovered */\n    &::-webkit-scrollbar-track:hover {\n      background-color: #f0f0f0; /* Change color on hover */\n    }\n  \n    /* Customize scrollbar thumb when hovered */\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: #dadada; /* Change thumb color on hover */\n    }\n  }\n\n  .with-margin {\n    margin-top: 39px !important;\n  }\n  \n  /* .custom-acrdn-btn:not(.collapsed)::after{\n    position:absolute !important ;\n    left: 85% !important; \n    transition: var(--bs-accordion-btn-icon-transition) !important;\n  } */\n  @media screen and (max-width:576px) {\n    .with-margin {\n      margin-top: 2px !important;\n    }\n    .fixedPosition {\n      position: unset;\n       }\n       .scrollable2 {\n        padding-left: 5px;\n        height: fit-content\n         \n        }\n  }\n  @media screen and (max-width: 768px) {\n    .text-blue{\n     font-size: 12px;\n     }\n     .override{\n     padding-left: 0% !important;\n     }\n    .custom-acrdn-btn::after{\n     padding-right:0px;\n   }\n   .sidebar{\n     padding-right: 0px !important;\n   }\n   .scrollable1{\n     padding-right: 0px;\n   }\n   }\n   @media screen and (max-width: 1200px) {\n     .text-blue{\n      font-size: 12px !important;\n      }\n     .custom-acrdn-btn::after{\n      padding-right:0px;\n    }\n    .sidebar{\n      padding-right: 0px !important;\n    }\n    .scrollable1{\n      padding-right: 0px;\n    }\n    .override{\n     padding-left: 5px !important;\n    }\n    }\n    @media screen and (max-width: 1440px) {\n     .text-blue{\n      font-size: 14px;\n      }\n     .custom-acrdn-btn::after{\n      padding-right:0px;\n    }\n    .sidebar{\n      padding-right: 0px !important;\n    }\n    .scrollable1{\n      padding-right: 0px;\n    }\n    .override{\n     padding-left: 5px !important;\n    }\n    }\n    @media screen and (min-width:768px) and (max-width: 991px){\n      .sort-hide{\n        display: none;\n      }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
